import {User} from './user';
import {Automat} from './automat';

export class Firms {

    _id?: string;
    name: string;
    users: [User];
    automats: [Automat];
    updatedAt: string;
    createdAt: string;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/firms.ts